/* eslint-disable */
var ensureStructure = function ensureStructure(window) {
  window.digitalData = window.digitalData || {};
  window.digitalData.page = window.digitalData.page || {};
  window.digitalData.page.lightBox = window.digitalData.page.lightBox || {};
  window.digitalData.page.lightBox.type = window.digitalData.page.lightBox.type || [];
  window.digitalData.page.lightBox.clickOrigin = window.digitalData.page.lightBox.clickOrigin || '';
  window.digitalData.page.lightBox.product = window.digitalData.page.lightBox.product || [];
  window.digitalData.event = window.digitalData.event || [];

  window.digitalData.track = window.digitalData.track || function () {};
};

var buildProduct = function buildProduct(id, price, quantity) {
  return {
    id: id,
    price: price,
    quantity: quantity
  };
};

var buildProductList = function buildProductList(analyticsData) {
  var quantity = analyticsData.quantity,
      hostPartNumber = analyticsData.hostPartNumber,
      hostPrice = analyticsData.hostPrice,
      warrantyPartNumber = analyticsData.warrantyPartNumber,
      warrantyPrice = analyticsData.warrantyPrice;
  return [buildProduct(hostPartNumber, hostPrice, quantity), buildProduct(warrantyPartNumber, warrantyPrice, quantity)];
};

var onProductCareSlidingPanelOpen = function onProductCareSlidingPanelOpen(analyticsData, window) {
  var isMonthly = analyticsData.isMonthly;
  ensureStructure(window);
  var pageName = isMonthly ? analyticsData.monthlyPageName : analyticsData.pageName;
  var clickOrigin = isMonthly ? analyticsData.monthlyClickOrigin : analyticsData.clickOrigin;
  var type = isMonthly ? 'monthlyProductCare' : 'productCare';
  var trackEvent = isMonthly ? 'monthlyProductCareLbPage' : 'productCareLbPage';
  window.digitalData.page.lightBox.clickOrigin = clickOrigin || '';
  window.digitalData.page.lightBox.pageName = pageName || '';
  window.digitalData.page.lightBox.type = type;
  var products = buildProductList(analyticsData);
  window.digitalData.page.lightBox.product = products;
  window.digitalData.track(trackEvent);
};

var onProductCareSlidingPanelClose = function onProductCareSlidingPanelClose(analyticsData, window) {
  ensureStructure(window);

  if (analyticsData.shouldTrackCloseModal) {
    window.digitalData.page.lightBox = null;
  }
};

var onProductCareAcceptTerms = function onProductCareAcceptTerms(analyticsData, window) {
  ensureStructure(window);

  if (analyticsData.shouldTrackTermsAndConditions) {
    var event = {
      eventInfo: {
        eventName: 'productCareLbTermsAccepted',
        eventAction: 'product care lb terms accepted'
      }
    };
    window.digitalData.event.push(event);
    window.digitalData.track('productCareLbTermsAccepted');
  }
};

var onProductCareAddToTrolley = function onProductCareAddToTrolley(analyticsData, window) {
  ensureStructure(window);

  if (analyticsData.shouldTrackAddToTrolley) {
    var event = {
      eventInfo: {
        eventName: 'addToTrolley',
        eventAction: 'Add to Trolley'
      },
      attributes: {
        product: buildProductList(analyticsData),
        clickOrigin: 'productCareLb:ATT'
      }
    };
    window.digitalData.event.push(event);
    window.digitalData.track(event.eventInfo.eventName);
  }
};

var onProductCareRemoveFromTrolley = function onProductCareRemoveFromTrolley(analyticsData, window) {
  ensureStructure(window);

  if (analyticsData.shouldTrackRemoveFromTrolley) {
    var event = {
      eventInfo: {
        eventName: analyticsData.pageIdentifier ? "".concat(analyticsData.pageIdentifier, "_itemRemoved") : 'itemRemoved',
        eventAction: analyticsData.pageIdentifier ? "".concat(analyticsData.pageIdentifier.toUpperCase(), " Item Removed") : 'Item Removed'
      },
      attributes: {
        itemIndex: analyticsData.itemIndex,
        clickOrigin: analyticsData.pageIdentifier ? "".concat(analyticsData.pageIdentifier.toUpperCase(), ":productCareLb:RFT") : 'productCareLb:RFT'
      }
    };
    window.digitalData.event.push(event);
    window.digitalData.track(event.eventInfo.eventName);
  }
};

export default {
  onProductCareSlidingPanelOpen: onProductCareSlidingPanelOpen,
  onProductCareAddToTrolley: onProductCareAddToTrolley,
  onProductCareSlidingPanelClose: onProductCareSlidingPanelClose,
  onProductCareAcceptTerms: onProductCareAcceptTerms,
  onProductCareRemoveFromTrolley: onProductCareRemoveFromTrolley
};